<template>
  <q-page class="main">
    <common-form :action="$route('object-group.store')">
      <q-card class="page-card">
        <q-card-section class="page-card__main-content">
          <h1 class="heading-2 q-mb-lg">Nieuwe subcategorie</h1>
          <object-group-form />
        </q-card-section>
        <q-separator />
        <q-card-actions align="right" class="q-pa-md">
          <accent-button label="Opslaan" type="submit"/>
        </q-card-actions>
      </q-card>
      <sticky-top-bar />
    </common-form>
  </q-page>
</template>

<script>
import ObjectGroupForm from './ObjectGroupForm'

export default {
  components: {
    ObjectGroupForm
  }
}
</script>
